import { axios } from "@/core/axios";
import type { CreateInsightsFeedbackRequest, InsightsFeedback } from "../types";

export const insightsFeedbackEndpoints = {
    createInsightsFeedback: async (payload: CreateInsightsFeedbackRequest): Promise<InsightsFeedback> => {
        try {
            const response = await axios.post<InsightsFeedback>("/insights-feedback", payload);
            return response.data;
        } catch (error) {
            console.error("Error creating insights feedback:", error);
            throw error;
        }
    },

    listInsightsFeedback: async (options?: { limit?: number }): Promise<InsightsFeedback[]> => {
        try {
            const limit = options?.limit ?? 100;
            const response = await axios.get<InsightsFeedback[]>(`/insights-feedback?limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching insights feedback list:", error);
            throw error;
        }
    },

    getInsightsFeedbackById: async (id: number): Promise<InsightsFeedback> => {
        try {
            const response = await axios.get<InsightsFeedback>(`/insights-feedback?id=${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching insights feedback:", error);
            throw error;
        }
    },
};
